export default __webpack_public_path__ + "static/mev-icon-45c28ea91ad934f66298766a1c63fc1b.png";